import { AustinIcon, ChicagoIcon, DenverIcon, HoustonIcon, LondonIcon, MelbourneIcon, MiamiIcon, NewYorkIcon, RemoteUsIcon, RemoteLatamIcon, RemoteEmeaIcon, SaoPauloIcon, SfIcon, SingaporeIcon, SydneyIcon, TlvIcon, TokyoIcon, WarsawIcon, ParisIcon, MunichIcon, AtlantaIcon, MexicoCityIcon, ZurichIcon, AmsterdamIcon, BrazilIcon } from "./icons/index.js";
export default [
    {
        id: "telaviv",
        name: "Tel-Aviv, IL",
        Icon: TlvIcon
    },
    {
        id: "newyork",
        name: "New York, US",
        Icon: NewYorkIcon
    },
    {
        id: "denver",
        name: "Denver, US",
        Icon: DenverIcon
    },
    {
        id: "miami",
        name: "Miami , US",
        Icon: MiamiIcon
    },
    {
        id: "sf",
        name: "San Francisco, US",
        Icon: SfIcon
    },
    {
        id: "chicago",
        name: "Chicago, US",
        Icon: ChicagoIcon
    },
    {
        id: "houston",
        name: "Houston, US",
        Icon: HoustonIcon
    },
    {
        id: "austin",
        name: "Austin, US",
        Icon: AustinIcon
    },
    {
        id: "london",
        name: "London, UK",
        Icon: LondonIcon
    },
    {
        id: "sydney",
        name: "Sydney, AU",
        Icon: SydneyIcon
    },
    {
        id: "melbourne",
        name: "Melbourne, AU",
        Icon: MelbourneIcon
    },
    {
        id: "warsaw",
        name: "Warsaw, PL",
        Icon: WarsawIcon
    },
    {
        id: "saopaulo",
        name: "Sao Paulo, BR",
        Icon: SaoPauloIcon
    },
    {
        id: "tokyo",
        name: "Tokyo, Japan",
        Icon: TokyoIcon
    },
    {
        id: "singapore",
        name: "Singapore",
        Icon: SingaporeIcon
    },
    {
        id: "remote-us",
        name: "Remote, US",
        Icon: RemoteUsIcon
    },
    {
        id: "remote-latam",
        name: "Remote, LATAM",
        Icon: RemoteLatamIcon
    },
    {
        id: "remote-emea",
        name: "Remote, EMEA",
        Icon: RemoteEmeaIcon
    },
    {
        id: "paris",
        name: "Paris, FR",
        Icon: ParisIcon
    },
    {
        id: "munich",
        name: "Munich, DE",
        Icon: MunichIcon
    },
    {
        id: "atlanta",
        name: "Atlanta, US",
        Icon: AtlantaIcon
    },
    {
        id: "mexicocity",
        name: "Mexico City, MX",
        Icon: MexicoCityIcon
    },
    {
        id: "zurich",
        name: "Zurich, CH",
        Icon: ZurichIcon
    },
    {
        id: "amsterdam",
        name: "Amsterdam, NL",
        Icon: AmsterdamIcon
    },
    {
        id: "brazil",
        name: "Brazil",
        Icon: BrazilIcon
    }
];
